var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('selected', _vm.option)}}},[_c('span',{staticClass:"w-full block"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }